import React from 'react'
import { connect } from 'react-redux'
import UserActions from '../../Redux/UserRedux'

import CleanObject from '../../Utils/ObjectCleaner'

class UpdateAdmin extends React.Component {
  constructor (props) {
    super (props)
    this.roles = [
      { value: 'admin', label: 'Admin' },
      { value: 'finance', label: 'Finance' },
      { value: 'cs', label: 'CS' },
    ]
    this.state = {
      form: {
        first_name: props.detail.first_name,
        last_name: props.detail.last_name,
        password: '',
        active: props.detail.active ? 'active' : 'disabled'
      }
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value.replace(/[^\x20-\x7E]/g, '')
    if (event.target.type === 'number') {
      val = parseInt(val, 10)
    }
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = this.state.form
    form = CleanObject(form)
    if (form.active === "active") {
      form.active = true
    } else {
      form.active = false
    }

    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.updateUser(data)
    this.props.closeModal()
  }

  render () {
    return (
      <div className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Create Admin</h4>
        </div>

        <form onSubmit={(event) => this._submit(event)}>
          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">First Name</label>
            </div>
            <div className="col-9">
              <input type="text" required placeholder="First Name" className="form-control" value={this.state.form.first_name} onChange={(event) => this._inputChange(event, 'first_name')}/>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">Last Name</label>
            </div>
            <div className="col-9">
              <input type="text" required placeholder="Last Name" className="form-control" value={this.state.form.last_name} onChange={(event) => this._inputChange(event, 'last_name')}/>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">Password</label>
            </div>
            <div className="col-9">
              <input type="password" placeholder="password" className="form-control" value={this.state.form.password} onChange={(event) => this._inputChange(event, 'password')}/>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">Status</label>
            </div>
            <div className="col-9">
              <select className="form-control" value={this.state.form.active} onChange={(event) => this._inputChange(event, 'active')}>
                <option value="active">Active</option>
                <option value="disabled">Disabled</option>
              </select>
            </div>
          </div>

          <div className="form-group d-flex justify-content-end">
            <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
            <button
              className="btn btn-lg btn-primary"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  updateUser: (data) => dispatch(UserActions.userUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateAdmin)


// WEBPACK FOOTER //
// ./src/Containers/ManageAdmin/UpdateAdmin.js